export namespace ClientHooks {
    export async function init() {
        // Add content here
    }

    export async function preLogin() {
        // Add content here
    }

    export async function postLogin() {
        const {default: store} = await import('@/store');
        const {LoginTypes} = await import('@/enums/LoginTypes.enum');
        // Surveys are not meant for sales partners
        if (store.state.userType === LoginTypes.PARTNER) {
            return;
        }
        const {SurveyManagerApi} = await import('@/classes/api/survey-manager.api.class');
        await SurveyManagerApi.response.getAvailableSurveys();
    }

    export async function preLogout() {
        // Add content here
    }

    export async function postLogout() {
        // Add content here
    }
}
